<template>
  <div class="sp-template">
    <div class="h-title">保险订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="订单号">
            <el-input type="textarea" v-model="conditions.orderIdText" placeholder="多个订单号用回车分割"></el-input>
          </el-form-item>

          <el-form-item label="批次号">
            <el-input type="textarea" v-model="conditions.batchIdText" placeholder="多个批次号用回车分割"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="search-form__buttons">
              <el-button  type="primary" size="small" @click="searchTask">搜 索</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane  label="待审核" name="0"></el-tab-pane>
          <el-tab-pane  label="待提交" name="1"></el-tab-pane>
          <el-tab-pane  label="已购买" name="2"></el-tab-pane>
          <el-tab-pane  label="已作废" name="-1"></el-tab-pane>
        </el-tabs>
        <div class="button-groups" >
          <el-button size="small" @click="popCheck()" v-show="conditions.status==0" >审核</el-button>
          <el-button size="small" @click="popBuy()"  v-show="conditions.status==1" >提交订单</el-button>

          <el-button size="small" @click="exportAll()"  v-show="conditions.status==2" >导出</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="batchId" label="批次号">
          <template slot-scope="scope">
              <el-button type="text" @click.native="showInsuranceOrderIds(scope.row.batchId)">{{scope.row.batchId}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column prop="totalCarton" label="箱数"></el-table-column>
        <el-table-column prop="totalWeight" label="重量"></el-table-column>     
        <el-table-column prop="totalValue" label="申报总价值"></el-table-column>   
        <el-table-column label="是否自主购买">
          <template slot-scope="scope">
            {{scope.row.customerPurchase ? '是':'否'}}
          </template>
        </el-table-column>        

        <el-table-column v-if="conditions.status!=0" prop="fromArea" label="起运港"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="toArea" label="目的港"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="ladingNumber" label="柜号/提单号"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="transportNumber" label="运单号"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="airLandNumber" label="航班/班列号"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="fromTime" label="起运时间"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="currency" label="币种"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="insuranceAddition" label="加成比例"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="amount" label="金额"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="fbaId" label="fbaID"></el-table-column>
        <el-table-column v-if="conditions.status!=0" prop="fbaAddress" label="fba地址"></el-table-column>

        <el-table-column v-if="conditions.status==2" prop="cost" label="成本"></el-table-column>
        <el-table-column v-if="conditions.status==2" prop="insuranceOrderId" label="保单号"></el-table-column>
        <el-table-column v-if="conditions.status==2" label="装箱单">
          <template slot-scope="scope">
            <a class="el-button el-button--text el-button--small" :href="scope.row.fileUrl" target="_blank" v-if="scope.row.fileUrl!= null && scope.row.fileUrl!=''" >下载</a>
          </template>
        </el-table-column>

        <el-table-column v-if="conditions.status==2" label="购买时间">
          <template slot-scope="scope">
            {{dateFormat(new Date(scope.row.purchasedTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>

        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{dateFormat(new Date(scope.row.createdAt), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作"  v-if="conditions.status==1" >
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="popEdit(scope.row)"  v-if="conditions.status==1" > 编辑订单</el-button>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 500, 2000, 10000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 审核弹框 -->
    <el-dialog title="审核" class="common-select__dialog" :visible.sync="dialogCheckVisible" width="30%">

      <el-form size="small" label-width="100px">
          <el-form-item label="是否通过">
						<el-select v-model="isPass" >
              <el-option key="1" label="通过" value="1"></el-option>
              <el-option key="-1" label="不通过" value="-1"></el-option>
            </el-select>
					</el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="checkSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 购买保险弹框 -->
    <el-dialog title="提交购买" class="common-select__dialog" :visible.sync="dialogBuyVisible" width="30%">

      <el-form size="small" label-width="100px">
          <el-form-item label="承险级别">
						<el-select v-model="sumbitForm.categoryId" @change="changeCategory" >
              <el-option v-for="item in categorys" :key="item.category_id" :label="item.category_name" :value="item.category_id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="险种类别">
						<el-select v-model="sumbitForm.kindId" >
              <el-option v-for="item in kinds" :key="item.kind_id" :label="item.kind_name" :value="item.kind_id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="供应商">
            <el-select v-model="sumbitForm.supplierId" filterable clearable>
              <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogBuyVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="buySubmit()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="编辑" :visible.sync="dialogEditVisible" width="400px">
      <el-form size="small" label-width="100px" >
  
        <el-form-item label="起运港">
         <el-input v-model.lazy="editData.fromArea" ></el-input>
        </el-form-item>

        <el-form-item label="目的港">
          <el-input v-model.lazy="editData.toArea" ></el-input>
         </el-form-item>
         <el-form-item label="柜号/提单号">
          <el-input v-model.lazy="editData.ladingNumber" ></el-input>
         </el-form-item>
         <el-form-item label="运单号">
          <el-input v-model.lazy="editData.transportNumber" ></el-input>
         </el-form-item>
         <el-form-item label="航班/班列号">
          <el-input v-model.lazy="editData.airLandNumber" ></el-input>
         </el-form-item>
  
         <el-form-item label="起运时间">
         <el-date-picker v-model="editData.fromTime" type="date" value-format="yyyy-MM-dd" placeholder="起运时间" style="width:200px;"></el-date-picker>
        </el-form-item>

        <el-form-item label="币种">
          <el-select v-model.lazy="editData.currency"  >
            <el-option label="usd" value="usd"></el-option>
            <el-option label="rmb" value="rmb"></el-option>              
          </el-select>
         </el-form-item>

         <el-form-item label="申报总价值">
          <el-input v-model.lazy="editData.totalValue" ></el-input>
         </el-form-item>

         <el-form-item label="加成比例">
            <el-select v-model.lazy="editData.insuranceAddition"  >
              <el-option label="1" value="1"></el-option>
              <el-option label="1.1" value="1.1"></el-option>              
            </el-select>
         </el-form-item> 

         <el-form-item label="fba ID">
          <el-input v-model.lazy="editData.fbaId" ></el-input>
         </el-form-item>

         <el-form-item label="fba 地址">
          <el-input type="textarea" v-model.lazy="editData.fbaAddress" ></el-input>
         </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogEditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit()">确 定</el-button>
      </div>
    </el-dialog>

<!-- 批次点击保险订单详情 -->
        <el-dialog title="批次保险订单" :visible.sync="batchInsuranceOrderIdsShow" width="20%">
            
        <el-form size="small" inline>
          <el-form-item label="订单号:" label-width="70px" >
            <p v-for="(item, index) in formatRefNumber(batchOrderIds)" :key="index">{{item}}</p>
            </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 到达 -->
  </div>

  


</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      categorys:[],
      categoryMap: {},
      kinds:[],
      sumbitForm: {
        categoryId: "",
        kindId: "",
        supplierId: ""
      },   
      suppliers: [],   
      supplierMap: {},
      isPass: "1",
      dialogCheckVisible: false, 
      dialogBuyVisible: false, 
      tableData: [],
      batchOrderIds: [],
      multipleSelection: [],
      batchInsuranceOrderIdsShow: false,
      conditions: {
        orderIdText:'',
        batchIdText: "",
        startDate: "",
        endDate: "",
        status: 0        
      },

      dialogEditVisible:  false,
      editData: {},
      total: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      
      this.querySupplier();
      this.query();
    }, 1000);
  },
  methods: {
        ...mapMutations([
      "setManualTrackingNumbers",
      "setOrderListTable",
      "setOrderListConditions",
      "setOrderListSearchMore"
    ]),
    formatRefNumber(refNumber) {
      let arr = refNumber;
      arr.forEach((item, index) => {
        if (item === " " || item === ",") {
          arr.splice(index, 1);
        }
      });
      return arr;
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;

      this.conditions.orderIds = [];
      this.conditions.batchIds = [];

      if(this.conditions.orderIdText){
        this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
      }
      if(this.conditions.batchIdText){
        this.conditions.batchIds = this.conditions.batchIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
      }

      this.conditions.currentPage = this.currentPage;
      this.conditions.pageSize = this.pageSize;
      
      //  this.tableData = [{"batchId": "11111", "orderId": "222222222"}]
      //  return;

      this.$request1({
        method: 'post',
        url: '/insurance/query',
        data: _this.conditions,
        withCredentials: true,
        header:{
	        'Content-Type':'application/json'
	      }
      })
        .then(response => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 审核弹框
    popCheck() {
      // console.log(this.multipleSelection.length);
      if(this.multipleSelection.length == 0){
        this.$message.error('请勾选要审核的保险订单');
        return;
      }
      this.dialogCheckVisible = true;

    },
    // 审核提交
    checkSubmit(){
      let _this = this;
      let ids = this.multipleSelection.map(a  => a.id);

      // console.log(ids);
      // return;
      this.$request1
        .post(
          '/insurance/audit',
          {
            ids: ids,
            status: _this.isPass

          },
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message.success("提交成功");
            _this.dialogCheckVisible = false
            _this.query();

          } else {
            _this.$message.error(response.data.message);
          }
        });

    },
    popEdit(row) {      
      this.dialogEditVisible = true;
        this.editData = row;

    },
    editSubmit(){
      let _this = this;
      this.$request1
        .post(
          '/insurance/update',
          _this.editData,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message.success("提交成功");
            _this.dialogEditVisible = false
            _this.query();

          } else {
            _this.$message.error(response.data.message);
          }
        });

    },
    // 改变险种
    changeCategory(categoryId){
      let _this = this;
        console.log("categoryId===>", categoryId);
        this.kinds = _this.categoryMap[categoryId]
        _this.kindId = "";
    },
    exportAll(){
      let _this = this;
      if(this.multipleSelection.length == 0){
        this.$message.error('请勾选要导出的订单');
        return;
      }

      // console.log(orderIds, batchIds);
      // return;

      var url = tmsSpringUrl + '/insurance/query';

      var form = document.createElement("form");
      form.method = "post";
      form.action = url;
      form.target = "_blank";
      document.body.appendChild(form);

      this.multipleSelection.forEach(a => {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "ids[]";
        input.value = a.id;
        form.appendChild(input);
      });

      let d = {status:2, export:1}
      Object.keys(d).forEach(key => {
        var input1 = document.createElement("input");
        input1.type = "hidden";
        input1.name = key;
        input1.value = d[key];
        form.appendChild(input1);
      })

      var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);

      form.submit();

    },
    // 提交购买保险 弹框
    popBuy(){
      let _this = this;
      if(this.multipleSelection.length == 0){
        this.$message.error('请勾选要购买保险的订单');
        return;
      }
      this.dialogBuyVisible = true;

      _this.categoryId = "";
      _this.kindId = "";
      this.$request1({
            method: 'get',
            url: '/operation/queryInsuranceCategory'
        })
        .then(response => {          
            let cate = response.data.data;
            console.log(cate)
            _this.categorys = cate
            _this.kinds = cate[0].list

            _this.categoryMap = {};
            cate.forEach(a => {
              _this.categoryMap[a.category_id] = a.list
            })
        })
    },
    // 提交 购买保险
    buySubmit(){
      let _this = this;
      if(!_this.sumbitForm.categoryId  || !_this.sumbitForm.kindId ){
        this.$message.error('请选择承险级别和险种类别');
        return;
      }
      if(!_this.sumbitForm.supplierId){
        this.$message.error('请选择供应商');
        return;
      }

      if(!this.checkData(this.multipleSelection)){        
        return;
      }

      let ids = this.multipleSelection.map(a  => a.id);

      this.$request1
        .post(
          '/insurance/submit',
          {
            ids: ids,
            categoryId: _this.sumbitForm.categoryId,
            kindId: _this.sumbitForm.kindId,
            supplierId: _this.sumbitForm.supplierId,
            status: 2

          },
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message.success("提交成功");
            _this.dialogBuyVisible = false
            _this.query();

          } else {
            _this.$message.error(response.data.message);
          }
        });

    },
    //根据批次id查询购买保险的订单号
    showInsuranceOrderIds(batchId){
      this.batchInsuranceOrderIdsShow = true
       this.$request1
        .post(
          '/insurance/batch-insurance-order',
          {},
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        ).then(response => {
          if (response.data.success) {
            this.batchOrderIds = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 提交前校验
    checkData(data){
        
        for (let i = 0; i < data.length; i++) {
          let d = data[i];
          if(!d.fromArea){
              this.$message.error('请补充起运港');
              return false;
          }
          if(!d.toArea){
              this.$message.error('请补充目的港');
              return false;
          }
          if(!d.ladingNumber){
              this.$message.error('请补充柜号/提单号');
              return false;
          }
          if(!d.transportNumber){
              this.$message.error('请补充运单号');
              return false;
          }
          if(!d.airLandNumber){
              this.$message.error('请补充航班/班列号');
              return false;
          }
          if(!d.fromTime){
              this.$message.error('请补充起运时间');
              return false;
          }
          if(!d.currency){
              this.$message.error('请补充币种');
              return false;
          }
          if(!d.totalValue){
              this.$message.error('请补充申报总价值');
              return false;
          }
          if(!d.insuranceAddition){
              this.$message.error('请补充加成比例');
              return false;
          }
          if(!d.fbaId){
              this.$message.error('请补充fba id');
              return false;
          }
          if(!d.fbaAddress){
              this.$message.error('请补充fba 地址');
              return false;
          }
          
        }
        return true;
    },
    //多选按钮
    handleSelectionChange(val) {
      console.log(">>>>>>val=", val);
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    dateFormat(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style>
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
  white-space: pre-wrap !important;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/insuranceorder.vue